export type TextAdFontOption = {
  value: string;
  label: string;
  cssFamily: string;
  preview: string;
};

export const TEXT_AD_DEFAULT_FONT = 'roboto_regular';

export const TEXT_AD_FONT_OPTIONS: TextAdFontOption[] = [
  { value: 'arial_bold', label: 'Arial Bold', cssFamily: '"AdFont Arial Bold", "Arial", sans-serif', preview: 'Arial Bold' },
  { value: 'arial_regular', label: 'Arial Regular', cssFamily: '"AdFont Arial Regular", "Arial", sans-serif', preview: 'Arial Regular' },
  { value: 'comic_neue_bold', label: 'Comic Neue Bold', cssFamily: '"AdFont Comic Neue Bold", "Comic Sans MS", cursive', preview: 'Comic Neue Bold' },
  { value: 'comic_neue_regular', label: 'Comic Neue Regular', cssFamily: '"AdFont Comic Neue Regular", "Comic Sans MS", cursive', preview: 'Comic Neue Regular' },
  { value: 'courgette_regular', label: 'Courgette', cssFamily: '"AdFont Courgette Regular", cursive', preview: 'Courgette' },
  { value: 'courier_prime_bold', label: 'Courier Prime Bold', cssFamily: '"AdFont Courier Prime Bold", "Courier New", monospace', preview: 'Courier Prime Bold' },
  { value: 'courier_prime_regular', label: 'Courier Prime Regular', cssFamily: '"AdFont Courier Prime Regular", "Courier New", monospace', preview: 'Courier Prime Regular' },
  { value: 'doto_regular', label: 'Doto', cssFamily: '"AdFont Doto Regular", sans-serif', preview: 'Doto' },
  { value: 'kode_mono_regular', label: 'Kode Mono', cssFamily: '"AdFont Kode Mono Regular", monospace', preview: 'Kode Mono' },
  { value: 'monotype_corsiva_bold', label: 'Monotype Corsiva Bold', cssFamily: '"AdFont Monotype Corsiva Bold", cursive', preview: 'Monotype Corsiva Bold' },
  { value: 'monotype_corsiva_regular', label: 'Monotype Corsiva Regular', cssFamily: '"AdFont Monotype Corsiva Regular", cursive', preview: 'Monotype Corsiva Regular' },
  { value: 'roboto_bold', label: 'Roboto Bold', cssFamily: '"AdFont Roboto Bold", "Roboto", sans-serif', preview: 'Roboto Bold' },
  { value: 'roboto_regular', label: 'Roboto Regular', cssFamily: '"AdFont Roboto Regular", "Roboto", sans-serif', preview: 'Roboto Regular' },
  { value: 'rubik_mono_one_regular', label: 'Rubik Mono One', cssFamily: '"AdFont Rubik Mono One Regular", monospace', preview: 'Rubik Mono One' },
  { value: 'sixtyfour_regular', label: 'Sixtyfour', cssFamily: '"AdFont Sixtyfour Regular", monospace', preview: 'Sixtyfour' },
  { value: 'tinos_bold', label: 'Tinos Bold', cssFamily: '"AdFont Tinos Bold", serif', preview: 'Tinos Bold' },
  { value: 'tinos_regular', label: 'Tinos Regular', cssFamily: '"AdFont Tinos Regular", serif', preview: 'Tinos Regular' },
];

export const resolveTextAdFontOption = (value?: string) => {
  if (!value) {
    return TEXT_AD_FONT_OPTIONS.find((font) => font.value === TEXT_AD_DEFAULT_FONT) || TEXT_AD_FONT_OPTIONS[0];
  }
  return TEXT_AD_FONT_OPTIONS.find((font) => font.value === value)
    || TEXT_AD_FONT_OPTIONS.find((font) => font.value === TEXT_AD_DEFAULT_FONT)
    || TEXT_AD_FONT_OPTIONS[0];
};

export const resolveTextAdFontFamily = (value?: string) => {
  return resolveTextAdFontOption(value)?.cssFamily || '"Roboto", "Noto Sans", "Helvetica", "Arial", sans-serif';
};

export const resolveTextAdFontLabel = (value?: string) => {
  return resolveTextAdFontOption(value)?.label || 'Roboto Regular';
};
